<template>
  <div>
    <el-form
      ref="formData"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="mini"
    >
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_label_containerName') || '箱型'"
            prop="containerName"
          >
            <dict-select
              filterable
              v-model="formData.containerName"
              url="/factory/masterContainer/dictSelect"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              size="mini"
              clearable
              :options="{ label: 'label', value: 'label' }"
              @change="changeContainerName"
            >
            </dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_label_editContainerNo') || '编辑柜号'"
          >
            <el-input v-model.trim="formData.editContainerNo" clearable>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="4">
          <el-row :gutter="10" class="mb-2">
            <el-col :span="24">
              <el-button
                type="primary"
                size="small"
                style="width: 100%"
                @click="() => (extendParameterDialogVisible = true)"
              >
                {{ '设置订舱放大系数' }}
              </el-button>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24">
              <el-card shadow="never">
                <div class="mb-2">
                  {{
                    `${$l('INDEX.form_containerSize') || '尺寸：'}
                    ${this.formData.containerSize || '--'}`
                  }}
                </div>
                <div class="mb-2">
                  {{
                    `${$l('INDEX.form_ loadWeight') || '载重：'}
                    ${this.formData.v_loadWeight || '--'}`
                  }}
                </div>
                <div class="mb-2">
                  {{
                    `${$l('INDEX.form_loadVolume') || '容积：'}
                    ${this.formData.v_loadVolume || '--'}`
                  }}
                </div>
                <div class="mb-2">
                  {{
                    `${$l('INDEX.form_label_containerNo') || '集装箱号'}：
                    ${this.formData.containerNo || '--'}`
                  }}
                </div>
                <div class="mb-2">
                  {{
                    `${$l('INDEX.form_label_sealNo') || '箱封号'}：
                    ${this.formData.sealNo || '--'}`
                  }}
                </div>
              </el-card>
            </el-col>
          </el-row>
          <el-row :gutter="10" class="mt-3">
            <el-col :span="12">
              <el-card shadow="never">
                <div style="text-align:center">
                  <div class="countTitle">
                    {{ $l('INDEX.form_containerGoodsQty') || '产品数' }}
                  </div>
                  <div class="countText-normal">
                    {{ this.containerGoodsQty || 0 }}
                  </div>
                </div>
              </el-card>
            </el-col>
            <el-col :span="12">
              <el-card shadow="never">
                <div style="text-align:center">
                  <div class="countTitle">
                    {{ $l('INDEX.form_label_boxQty') || '入柜箱数' }}
                  </div>
                  <div class="countText-normal">
                    {{ this.containerBoxQty || 0 }}
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
          <el-row :gutter="10" class="mt-3">
            <el-col :span="12">
              <el-card shadow="never">
                <div style="text-align:center">
                  <div class="countTitle">
                    入柜重量(kg)
                  </div>
                  <div
                    :class="
                      isWeightDanger ? 'countText-danger' : 'countText-normal'
                    "
                  >
                    {{ this.containerGrossWeight || 0 }}
                  </div>
                </div>
              </el-card>
            </el-col>
            <el-col :span="12">
              <el-card shadow="never">
                <div style="text-align:center">
                  <div class="countTitle">
                    {{
                      $l('INDEX.form_containerBookingVolume') || '入柜订舱体积'
                    }}
                  </div>
                  <div
                    :class="
                      isVolumeDanger ? 'countText-danger' : 'countText-normal'
                    "
                  >
                    {{ this.containerBookingVolume || 0 }}
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="20">
          <BoxTable
            ref="boxTable"
            :shipmentCode="shipmentCode"
            :shipmentContainerCode="shipmentContainerCode"
            type="checkbox"
            :disabled="disabled"
            @reload="getData"
          />
        </el-col>
      </el-row>
    </el-form>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">{{
          $l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button @click="close()" size="small">{{
          $l('INDEX.btn_no_save') || '不保存'
        }}</el-button>
        <el-button @click="save()" type="primary" size="small">{{
          $l('INDEX.btn_save') || '保存'
        }}</el-button>
      </span>
    </el-dialog>
    <ExtendParameterDialog
      v-if="extendParameterDialogVisible"
      :visible.sync="extendParameterDialogVisible"
      :title="'选择订舱放大类型'"
      :formData.sync="formData"
      @change="bookingVolumeChange"
    />
  </div>
</template>

<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import BoxTable from '../box-table'
import ExtendParameterDialog from '../lcl/extendParameterDialog.vue'
export default {
  components: { BoxTable, ExtendParameterDialog },
  mixins: [EditLoading],
  props: {
    disabled: { type: Boolean, default: false },
    shipmentCode: { type: String, default: '' },
    shipmentContainerCode: { type: String, default: '' },
  },
  data() {
    return {
      backDialogVisible: false,
      extendParameterDialogVisible: false,
      currencyUnitParams: { dictType: 'currencyUnit' },
      formData: {},
      rules: {},
      containerGoodsQty: 0,
      containerBoxQty: 0,
      containerGrossWeight: 0,
      containerBookingVolume: undefined,
    }
  },
  computed: {
    isVolumeDanger() {
      return this.containerBookingVolume > this.formData.loadVolume
    },
    isWeightDanger() {
      return this.containerGrossWeight > this.formData.loadWeight
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.shipmentContainerCode) return
      this.$api
        .shipmentContainerDetailApi({
          shipmentContainerCode: this.shipmentContainerCode,
        })
        .then((res) => {
          this.formData = res.body
          this.containerGoodsQty = res.body.containerGoodsQty || 0
          this.containerBoxQty = res.body.containerBoxQty || 0
          this.containerGrossWeight = res.body.containerGrossWeight || 0
          this.containerBookingVolume = res.body.containerBookingVolume || 0
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.formData])
      if (!result) return (this.backDialogVisible = false)

      this.loadingOpen()
      this.$api
        .shipmentContainerSaveApi({
          ...this.formData,
          shipmentCode: this.shipmentCode,
          shipmentContainerCode: this.shipmentContainerCode,
        })
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status !== 200) {
            this.$message.error(res.msg)
            return
          }
          this.$message({
            message: res.msg,
            type: 'success',
          })
          this.close()
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
    async changeContainerName() {
      let data = {}
      const { containerName } = this.formData
      if (containerName) {
        const res = await this.$api.masterContainerDetailByNameApi({
          containerName: this.formData.containerName,
        })
        data = res.body || {}
      }

      const {
        containerLength = 0,
        containerWidth = 0,
        containerHeight = 0,
        loadWeight = 0,
        loadVolume = 0,
      } = data

      this.formData.containerSize = `${containerLength}*${containerWidth}*${containerHeight}`
      this.formData.v_loadWeight = `${loadWeight}kg`
      this.formData.v_loadVolume = `${loadVolume}m³`
    },
    bookingVolumeChange(data) {
      this.loadingOpen()
      this.$api
        .shipmentContainerUpdateExtendParameterApi({
          ...data,
          shipmentCode: this.shipmentCode,
          shipmentContainerCode: this.shipmentContainerCode,
        })
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status !== 200) {
            this.$message.error(res.msg)
            return
          }
          this.$message({
            message: res.msg,
            type: 'success',
          })
          this.$refs.boxTable.loadData()
          this.getData()
        })
        .catch(() => {
          this.loadingClose()
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.countTitle {
  font-size: 12px;
}
.countText-normal {
  font-size: 20px;
  color: $color-text-normal;
}
.countText-danger {
  font-size: 20px;
  color: $color-danger;
}
</style>
